import { render, staticRenderFns } from "./DeliveryTripDetailPage.vue?vue&type=template&id=6382236f&scoped=true"
import script from "./DeliveryTripDetailPage.vue?vue&type=script&lang=js"
export * from "./DeliveryTripDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTripDetailPage.vue?vue&type=style&index=0&id=6382236f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382236f",
  null
  
)

export default component.exports